/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayPlayerMetricsDtoSchema } from "./goodLuck/core/DTOs/replayPlayerMetricsDtoSchema.ts";
import { z } from "zod/v4";

export const getUsersUseridReplayMetricsPathParamsSchema = z.object({
  userId: z.string(),
});

/**
 * @description OK
 */
export const getUsersUseridReplayMetrics200Schema = z.lazy(
  () => goodLuckCoreDTOsReplayPlayerMetricsDtoSchema,
);

export const getUsersUseridReplayMetricsQueryResponseSchema =
  getUsersUseridReplayMetrics200Schema;
